import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { bannerTheme } from "./bannerTheme";
const maybeApplyFocusBackground = _ref => {
  let {
    focusMode,
    themeMode
  } = _ref;
  return focusMode === "keyboard" ? `background-color: ${bannerTheme.action.hoverBackground(themeMode)};` : "";
};
export const BannerActionStyled = withFocusToggleClassName(styled("button")`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    min-width: 32px;
    padding: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return bannerTheme.action.padding(themeMode);
}};
    border: none;
    border-radius: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return bannerTheme.action.borderRadius(themeMode);
}};
    margin-left: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return bannerTheme.action.marginLeft(themeMode);
}};
    cursor: pointer;
    font-weight: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return bannerTheme.action.fontWeight(themeMode);
}};
    font-size: 14px;
    font-family: inherit; // Ensure we inherit from parent since many browsers override this in user-agent stylesheet.
    transition: background-color ${motion.animation.default};
    color: currentColor;

    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    white-space: nowrap;

    ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return createFocusRingStyles({
    theme: themeMode,
    componentRadius: "4px",
    gap: 1,
    componentBorderWidth: 1,
    innerColorOverride: "transparent"
  });
}};

    background-color: transparent;

    &:hover {
        background-color: ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return bannerTheme.action.hoverBackground(themeMode);
}};
    }

    &:active {
        background-color: ${_ref8 => {
  let {
    themeMode
  } = _ref8;
  return bannerTheme.action.pressBackground(themeMode);
}};
    }

    &:focus {
        ${maybeApplyFocusBackground}
    }
`);
BannerActionStyled.displayName = "BannerActionContainer";
//# sourceMappingURL=BannerActionStyled.js.map